/**
 * File types constants
 * These constants should be kept in sync with the API FileTypesEnum
 */

export const FileTypes = {
  // controls
  LINEART: 'lineart',
  DEPTH: 'depth',
  NORMAL: 'normal',
  DRAFT: 'draft',
  COLOR: 'color',
  CUSTOM: 'custom', // User-drawn custom controls
  // results
  RESULT: 'result',
} as const;

export type FileType = (typeof FileTypes)[keyof typeof FileTypes];

// Type-safe arrays for specific use cases
export const CONTROL_TYPES: FileType[] = [
  FileTypes.LINEART,
  FileTypes.DEPTH,
  FileTypes.NORMAL,
  FileTypes.DRAFT,
  FileTypes.COLOR,
  FileTypes.CUSTOM,
];

export const RESULT_TYPES: FileType[] = [FileTypes.RESULT];
